'use client'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { ReactNode, useState } from 'react'
import useSWR from 'swr'

import bigLogo from '../../../../public/img/gratialogo_horizontal_color.png'
import { GetAccountsType } from '@/app/api/public/account/route'
import { fetcher } from '@/util/fetcher'
import Button from '@/components/Button'
import Link from 'next/link'
import Divider from '@/components/Divider'

export default function NewUserRegistrationClient() {
  const router = useRouter()
  const [selectedAccount, setSelectedAccount] = useState<string>('default')
  const { data, isLoading, error } = useSWR<GetAccountsType>('/api/public/account', fetcher)

  const handleContinue = () => {
    router.push(`/signup?act=${selectedAccount}`)
  }

  if (isLoading)
    return (
      <Wrapper>
        <div className="flex w-full animate-pulse flex-col gap-4">
          <div className="h-16 w-full rounded bg-gray-200"></div>
          <div className="ml-auto h-8 w-1/2 rounded bg-gray-200"></div>
        </div>
      </Wrapper>
    )

  if (error) return <Wrapper>There was an error loading the page. Please refresh and try again.</Wrapper>

  return (
    <Wrapper>
      <label className="flex w-full max-w-xs flex-col">
        <div className="flex items-center justify-between px-1 py-2">
          <span className="text-sm">Which health system do you work for?</span>
        </div>
        <select
          className="h-12 min-h-12 cursor-pointer rounded-md border border-gray-300 text-sm focus:border-gray-300 focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
          defaultValue={selectedAccount}
          onChange={e => setSelectedAccount(e.target.value)}
        >
          <option disabled value="default">
            Pick one
          </option>
          {data?.map(account => {
            // More than a few things depend on this being this. Easiest way to handle this right now.
            if (account.name === 'Scion Health') {
              return (
                <option key={account.id} value={account.id}>
                  ScionHealth
                </option>
              )
            }
            return (
              <option key={account.id} value={account.id}>
                {account.name}
              </option>
            )
          })}
        </select>
      </label>
      <div className="mt-4 flex w-full justify-end">
        <Button className="w-1/2" onClick={handleContinue} disabled={selectedAccount === 'default'}>
          Continue
        </Button>
      </div>
      <Divider />
      <div className="flex justify-center">
        Already registered?{' '}
        <Link className="ml-1 cursor-pointer text-blue-50 underline hover:text-blue-medium" href="/signin">
          Sign in
        </Link>
      </div>
    </Wrapper>
  )
}

const Wrapper = ({ children }: { children: ReactNode }) => (
  <div className="h-screen w-full bg-gradient-to-tl from-bright-blue-10 to-bright-blue-50 px-4 py-16">
    <div className="flex h-full flex-col">
      <div className="absolute flex flex-col items-center" style={{ right: 'calc(50% - 125px)' }}>
        <Image src={bigLogo} priority alt="Logo" width={250} className="h-auto" />
      </div>
      <div className="mx-auto my-auto w-full max-w-sm rounded-xl bg-white p-10 shadow md:w-1/2 lg:w-1/3">
        {children}
      </div>
    </div>
  </div>
)
